import styled from 'styled-components'
import {NextIcon} from '@modifi/ui'

type propType = {
  expandItem: boolean
}
export const DisclosureWidget = styled(NextIcon)`
  transform: ${(props: propType): string =>
    props.expandItem ? 'rotate(-90deg)' : 'rotate(90deg)'};
  transition-duration: 0.2s;
  margin-left: 10px;
`
